import { createSlice, Reducer } from '@reduxjs/toolkit';
import {
  addScorecardsCases,
  addCareerMentorOptionsCases,
} from 'store/scorecards/index';
import { cloneDeep } from 'lodash-es';
import { resetState } from 'store/actions';
import {
  storeName,
  userScorecardsInitialState,
  initialFilters,
} from './config';

export * from './interfaces';

const userScorecards = createSlice({
  name: storeName,
  initialState: cloneDeep(userScorecardsInitialState),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resetState, (state) => {
      const newState = cloneDeep(userScorecardsInitialState);
      newState.filters = state.filters;
      Object.assign(state, newState);
    });
    addCareerMentorOptionsCases(builder, storeName);
    addScorecardsCases(builder, storeName, cloneDeep(initialFilters));
  },
});

export default userScorecards.reducer as Reducer<
  typeof userScorecardsInitialState
>;
